import { useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";

const useErrorHandler = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const toastRef = useRef(null);

  const ErrorHandler = (Error) => {
    const statusCode = Error.response.status;
    if (statusCode === 500) {
      toastRef.current = toast({
        position: "top",
        title: "Error",
        description: "An error has occured!",
        status: "error",
        duration: "5000",
        isClosable: "false",
      });
    } else if (statusCode === 401) {
      sessionStorage.clear();
      var data = Error.response.data;
      toastRef.current = toast({
        position: "top",
        title: "Warning",
        description: data.Message,
        status: "warning",
        duration: "5000",
        isClosable: "false",
      });
      navigate("/", { replace: true });
    } else if (statusCode === 404 || statusCode === 400) {
      var data = Error.response.data;
      toastRef.current = toast({
        position: "top",
        title: "Warning",
        description: data.Message,
        status: "warning",
        duration: "5000",
        isClosable: "false",
      });
    }
  };

  return {
    ErrorHandler,
  };
};

export default useErrorHandler;
